/*
 * @Descripttion:
 * @version:
 * @@Company: HDWB
 * @Author: cwl
 * @Date: 2022-04-11 13:43:44
 * @LastEditors: cwl
 * @LastEditTime: 2023-07-21 09:57:18
 */
import Vue from "vue";
import Vuex from "vuex";
import { getDomainInfoApi } from "../ports/getData";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    token: "",
    isPersonal: "",
    userId: "",
    isKeep: true,
    ssoApiBase: "/prod-api",
    ssoImageBase: "",
    ssoLoginJumpUrl: "/#",

    // memberJumpUrl: '/chooseMember',
    // 正式环境不添加后缀
    memberJumpUrl:
      process.env.VUE_APP_BASE_URL == "https://www.tibetmuseum.com.cn"
        ? "/"
        : "/chooseMember",

    cinemaJumpUrl: "/cinema/#",
    cinemaOrderJumpUrl: "/cinema/#/personal/order_list",
    ticketJumpUrl: "/museum/#",
    teamTicketJumpUrl: "/museum/#/team/index",
    teamTicketUserJumpUrl: "/museum/#/team/me",
    ticketOrderJumpUrl: "/museum/#/personal/order_list",
    touristsJumpUrl: "/museum/#/personal/contact", // 常用游客
    activityJumpUrl: "/activity/#/activity/activityList",
    activityOrderJumpUrl: "/activity/#/activity/myOrders",
    volunteerJumpUrl: "/web",
    studyJumpUrl: ""
  },
  mutations: {
    increment(state, val) {
      state.isKeep = val;
    },
    SET_TOKEN(state, token) {
      console.log(token);
      state.token = token;
    },
    SET_USER_ID(state, userId) {
      state.userId = userId;
    },
    SET_IS_PERSONAL(state, isPersonal) {
      state.isPersonal = isPersonal;
    },
    SET_STATE_BY_KEY(state, data) {
      state[data.key] = data.value;
    }
  },
  actions: {
    domainInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getDomainInfoApi()
          .then(({ data: res }) => {
            const urlKeyInfo = {
              ticket_url: [
                "cinemaJumpUrl",
                "cinemaOrderJumpUrl",
                "ticketJumpUrl",
                "teamTicketJumpUrl",
                "teamTicketUserJumpUrl",
                "ticketOrderJumpUrl",
                "touristsJumpUrl",
                "activityJumpUrl",
                "activityOrderJumpUrl"
              ],
              user_url: ["ssoApiBase", "ssoImageBase", "ssoLoginJumpUrl"],
              member_url: ["memberJumpUrl"],
              volunteer_url: ["volunteerJumpUrl"],
              study_url: ["studyJumpUrl"]
            };
            for (const key in res.data) {
              for (const itemKey of urlKeyInfo[key]) {
                // console.log(`commit('SET_STATE_BY_KEY',{key:'${itemKey}',value:'${res.data[key]+state[itemKey]}'})`);
                eval(
                  `commit('SET_STATE_BY_KEY',{key:'${itemKey}',value:'${res
                    .data[key] + state[itemKey]}'})`
                );
              }
            }
            resolve();
          })
          .catch(reject);
        // commit('UPDATE_LISTROWHISTORY')
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js